// Calendly popup widget opener.
// Loaded via /public/index.html (widget.css + widget.js).
// We track conversions to GA4 + Meta Pixel when the calendar opens.

const CALENDLY_BASE = "https://calendly.com/amy-eatdrinkconsulting";

// Embed-side brand styling — works on every Calendly plan (including free).
// Calendly hex values must be passed WITHOUT the leading '#'.
const PAGE_SETTINGS = {
    backgroundColor: "f5efe6", // brand cream
    primaryColor: "EF6818",    // brand orange
    textColor: "2d2a26",       // brand dark
    hideEventTypeDetails: false,
    hideLandingPageDetails: false,
    hideGdprBanner: true,
};

export function openCalendly(eventSlug, label) {
    if (typeof window === "undefined") return;
    const url = eventSlug ? `${CALENDLY_BASE}/${eventSlug}` : CALENDLY_BASE;

    // Track booking-intent events for analytics
    if (window.gtag) {
        window.gtag("event", "schedule_open", {
            event_category: "booking",
            event_label: label || "general",
        });
    }
    if (window.fbq) {
        window.fbq("track", "Schedule");
    }

    if (window.Calendly && typeof window.Calendly.initPopupWidget === "function") {
        window.Calendly.initPopupWidget({ url, pageSettings: PAGE_SETTINGS });
        return false;
    }
    // Fallback: open in new tab if Calendly script hasn't loaded yet
    window.open(url, "_blank", "noopener");
    return false;
}

